// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c16f91ae","763":"51484ce2"}[chunkId] + ".chunk.js";
};